import { connect } from 'react-redux';
import DashboardFilter from '../../components/filters/DashboardFilter';
import { getCohorts, getSubgroups } from '../../selectors';

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    meta: state.meta.dashboard,
    ages: state.filters.ages,
    cohorts: getCohorts(state),
    subgroups: getSubgroups(state),
    groups: state.filters.groups,
    periods: state.filters.periods || [],
    partners: state.filters.partners,
    withScope: state.filters.withScope,
  }
}

const DashboardFilterContainer = connect(
  mapStateToProps,
  null
)(DashboardFilter)

export default DashboardFilterContainer;
